import { format, formatDistanceToNowStrict, isValid, parseISO } from 'date-fns';

export function formatDate(value: string | Date | null | undefined, pattern = 'd MMM yyyy'): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? parseISO(value) : value;
  return isValid(date) ? format(date, pattern) : '—';
}

export function formatDateTime(value: string | Date | null | undefined): string {
  return formatDate(value, 'd MMM yyyy, HH:mm');
}

/** "3 hours ago" — used in activity feeds and the audit log. */
export function timeAgo(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const date = typeof value === 'string' ? parseISO(value) : value;
  if (!isValid(date)) return '—';
  return `${formatDistanceToNowStrict(date)} ago`;
}

/**
 * The API sends money as a decimal string so precision survives the wire.
 * Never parse it into a Number before formatting.
 */
export function formatMoney(amount: string | null | undefined, currency = 'AED'): string {
  if (amount === null || amount === undefined || amount === '') return '—';
  const [whole = '0', fraction = '00'] = amount.replace('-', '').split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const sign = amount.startsWith('-') ? '-' : '';
  return `${currency} ${sign}${grouped}.${fraction.padEnd(2, '0').slice(0, 2)}`;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[unit]}`;
}
